export default "__VITE_ASSET__7xiPcWt5__"